var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodeBooths(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13.5,
    height: 14.5875,
    viewBox: "0 0 13.5 14.5875",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.5 14.5875C1.0875 14.5875 0.734375 14.4406 0.440625 14.1469C0.146875 13.8531 0 13.5 0 13.0875V9.675L2.0625 7.33125L3.13125 8.4L1.63125 10.0875H11.8687L10.4062 8.4375L11.475 7.36875L13.5 9.675V13.0875C13.5 13.5 13.3531 13.8531 13.0594 14.1469C12.7656 14.4406 12.4125 14.5875 12 14.5875H1.5V14.5875M5.7 8.8875L3.09375 6.24375C2.80625 5.95625 2.6625 5.6 2.6625 5.175C2.6625 4.75 2.80625 4.39375 3.09375 4.10625L6.76875 0.43125C7.05625 0.14375 7.4125 0 7.8375 0C8.2625 0 8.61875 0.14375 8.90625 0.43125L11.55 3.0375C11.8375 3.325 11.9844 3.67813 11.9906 4.09688C11.9969 4.51563 11.8563 4.86875 11.5688 5.15625L7.81875 8.90625C7.53125 9.19375 7.17813 9.33438 6.75938 9.32812C6.34063 9.32187 5.9875 9.175 5.7 8.8875V8.8875M10.5 4.0875V4.0875V4.0875L7.8375 1.4625V1.4625V1.4625L4.125 5.175V5.175V5.175L6.7875 7.8V7.8V7.8L10.5 4.0875V4.0875",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeBooths);
export default __webpack_public_path__ + "static/media/node-booths.2ad52ca8da705318d36e3b2dbbc42139.svg";
export { ForwardRef as ReactComponent };